import { render, staticRenderFns } from "./BidButton.vue?vue&type=template&id=0f80faac&scoped=true&"
import script from "./BidButton.vue?vue&type=script&lang=js&"
export * from "./BidButton.vue?vue&type=script&lang=js&"
import style0 from "./BidButton.vue?vue&type=style&index=0&id=0f80faac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f80faac",
  null
  
)

export default component.exports